module.exports = __webpack_public_path__ + "images/tell_a_friend/tell_a_friend_lifesaver_app_home.png";